import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import { Link } from 'gatsby';
import { Seo } from "actb";
import { Button } from "antd";
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}>
      <Seo title="Page two" />
      <MDXTag name="h1" components={components}>{`Second MDX page`}</MDXTag>
      <MDXTag name="p" components={components}>{`This is again a MDX page.`}<Button><Link to="/examples/hello-antd/">{`Go to Hello Antd`}</Link></Button>{`Here an Ant Design button with Gatsby Link was inserted.`}</MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {};
    